// src/utils/keepAlive.js
// Pings the backend every 14 minutes to prevent Render free tier from sleeping.
// Render sleeps after 15 minutes of inactivity.

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";
const INTERVAL = 14 * 60 * 1000; // 14 minutes

let timer = null;

export const startKeepAlive = () => {
  if (timer) return; // already running

  const ping = async () => {
    try {
      await fetch(`${API_BASE}/health`, { method: "GET" });
    } catch {
      // Silently ignore — this is just a keep-alive ping
    }
  };

  // Ping immediately on start
  ping();

  // Then every 14 minutes
  timer = setInterval(ping, INTERVAL);
};

export const stopKeepAlive = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
};
